import React, { useEffect } from 'react';
import { FeatureFlag } from 'types/features';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

const SCRIPT_SRC = 'https://handhold.io/demo/embed.js';
const IFRAME_SRC =
    'https://handhold.io/demo/019d8c43-88b5-70ba-88b9-7cb47bc1ca51/tour?locale=en&mode=launcher&position=center';

const IFRAME_STYLE: React.CSSProperties = {
    position: 'fixed',
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 'var(--z-tooltip)',
    border: 'none',
    height: 0,
    width: 0,
    pointerEvents: 'auto',
};

const OnboardingAssistant = () => {
    const isEnabled = useIsFeatureEnabled(FeatureFlag.ENABLE_ONBOARDING_AI_ASSISTANT);

    useEffect(() => {
        if (!isEnabled) return;
        if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        document.head.appendChild(script);

        return () => {
            script.remove();
        };
    }, [isEnabled]);

    if (!isEnabled) return null;

    return <iframe src={IFRAME_SRC} allow="autoplay" title="Onboarding assistant" style={IFRAME_STYLE} />;
};

export default OnboardingAssistant;
